import UseCase from "core/useCase/UseCase";
import { GoogleWalletPass, WalletPassParams } from "domain/entity/WalletPass";
import { WalletRepository } from "domain/repository/WalletRepository";

export default class GetGoogleWalletPassUseCase extends UseCase<
  GoogleWalletPass,
  WalletPassParams
> {
  private repository: WalletRepository;

  constructor(repository: WalletRepository) {
    super();
    this.repository = repository;
  }

  execute = (params: WalletPassParams) =>
    this.repository.getGoogleWalletPass(params);
}
